import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'discover' }
  },
  {
    path: '/discover',
    name: 'discover',
    redirect: { name: 'feed', params: { type: 'popular' } },
  },
  {
    path: '/discover/:type/:param?',
    name: 'feed',
    props: true,
    component: () => import(/* webpackChunkName: "discover" */ '../views/Discover.vue'),
  },
  {
    path: '/create',
    name: 'create',
    component: () => import(/* webpackChunkName: "create" */ '../views/Create.vue')
  },
  {
    // Note that 'userId' is not really optional, but we need to declare it as such such that the nav link in App.vue
    // will still recognize the route
    path: '/profile/:userId?',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => import(/* webpackChunkName: "messages" */ '../views/Messages.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import(/* webpackChunkName: "sign-in" */ '../views/SignIn.vue')
  }
];

const router = new VueRouter({ routes });

export default router;
